import CtaButtonTw from '@components/buttons/ctaButtonTw'
import BackgroundImageV5 from '@components/imageModules/v5/backgroundImg_v5'
import WistiaVideo from '@components/video/wistiaVideo'
import { GATSBYIMGLOADING, IMAGELOADINGENUMS } from '@et/types/Enums'
import { IGatsbyImageDataObject } from '@et/types/Gatsby'
import { classNames } from '@utils/genUtils'
import { getVideo } from '@utils/videoUtils'
import { GatsbyImage, IGatsbyImageData } from 'gatsby-plugin-image'
import React from 'react'
import { twMerge } from 'tailwind-merge'

interface Props {
  bgImage?: IGatsbyImageDataObject
  boxImage?: IGatsbyImageDataObject
  videoId?: string
  scrollId?: string
  containerClasses?: string
  headlineClasses?: string
  textClasses?: string
  btnClasses?: string
  contentContainerCss?: string
  videoBgClasses?: string
  mp4?: {
    src: string
    posterSrc: IGatsbyImageDataObject
  }
  children?: React.ReactNode
  content: {
    header: string
    text: string
    buttonText?: string
  }
}

function VideoLayoutB(props: Props) {
  const {
    videoId,
    scrollId,
    containerClasses,
    contentContainerCss,
    headlineClasses,
    textClasses,
    btnClasses,
    videoBgClasses,
    mp4,
    bgImage,
    children,
    content: { header, text, buttonText },
    boxImage
  } = props

  return (
    <BackgroundImageV5
      innerDivClasses={videoBgClasses ? videoBgClasses : ''}
      bgImageClasses={twMerge('bgImageClasses hidden relative h-[300px] md:h-[500px] xl:block lg:absolute lg:h-full')}
      gatsbyDataImg={bgImage?.gatsbyImageData}
      showBlurImage={true}>
      <div className={twMerge(containerClasses ? containerClasses : '', `py-8 et-grid-basic lg:py-16 xl:py-28 z-3 relative`)}>

        <div className='relative col-span-2 col-start-2 my-8 md:col-start-3 md:col-span-10 lg:col-start-3 lg:col-span-10 xl:my-0 lg:flex lg:items-center xl:items-start xl:col-start-8 xl:col-span-6 xl:mx-[-30px] xxl:mr-[-100px]'>
          <div className='relative shadow-2xl z-2'>
            {videoId && <WistiaVideo videoId={videoId} />}
            {mp4 && getVideo({
              videoSrc: mp4.src,
              posterImg: mp4.posterSrc,
            })}

          </div>
        </div>

        <div className={twMerge('relative flex flex-col items-center col-span-2 col-start-2 text-center md:col-start-3 md:col-span-10 lg:col-start-3 lg:col-span-10 xl:row-start-1 lg:text-left lg:items-start lg:justify-center lg:pl-4 xl:pl-8 xl:mr-16 xl:col-start-2 xl:col-span-6 xxl:ml-[-100px]', contentContainerCss)}>

          <h2 className={classNames(headlineClasses ? headlineClasses : '', 'relative mb-4 text-3xl z-2 font-sentinel__SemiBoldItal lg:text-5xl ')}>
            {header}
          </h2>

          <p className={twMerge('relative px-4 mb-8 text-xl z-2 md:text-2xl lg:px-0 xl:text-xl xxl:mr-10', textClasses)}>
            {text}
          </p>

          {children}
          <div>
            <CtaButtonTw
              id={scrollId}
              className={classNames(btnClasses ? btnClasses : '', 'btn-lg')}
              text={buttonText ? buttonText : 'Enroll Now!'} />
          </div>

          {/* <div className='hidden absolute rotate-[116deg] z-1 top-0 left-0 w-[600px] lg:block lg:top-[-410px] lg:left-[-410px] lg:w-[550px] lg:rotate-[-24deg] xxl:w-[410px] xxl:top-[-290px] xxl:left-[-311px]'>
              <GatsbyImage
                image={flower.gatsbyImageData}
                loading={GATSBYIMGLOADING.LAZY}
                alt={'Flat Florals Project 1 Flower'} />
            </div> */}
        </div>

      </div>
    </BackgroundImageV5>

  )
}

export default VideoLayoutB
